import React, { Component } from 'react';
import { connect } from 'react-redux';

class KeySeo extends Component {
    componentDidUpdate(){
        document.getElementById("idKeySeoContent").value = this.props.key_seo;
    }
    handleInputChange = (e) => {
        // console.log('Content was updated:', e.target.getContent());
    }
    render() {
        return (
            <div className="card shadow mb-4">
                {/*<!-- Header - Accordion -->*/}
                <a href="#idKeySeo" className="d-block card-header py-3 collapsed" data-toggle="collapse" role="button" aria-expanded="false" aria-controls="idKeySeo">
                    <h6 className="m-0 font-weight-bold text-primary"><i className="fab fa-keycdn"></i> Key SEO</h6>
                </a>
                {/*<!-- Content - Blox Hinh anh -->*/}
                <div className="collapse" id="idKeySeo">
                    <div className="card-body row">
                        <div className="form-group col-12">
                            <textarea
                                className="form-control"
                                id="idKeySeoContent"
                                rows="5" 
                                placeholder="Key SEO"                                
                                onChange={this.handleInputChange}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(
    state => ({        
        InputContentProduct: state.InputContentProduct
    })
)(KeySeo);